import React from 'react';
import NavigationStepper, {
	NavigationStepperComponentParams,
	NavigationStepperItemType,
} from '../../../../../../Components/Stepper/NavigationStepper';
import SubTabNavigationStepperItems from '../../../../../../Components/Stepper/SubTabNavigationStepper/SubTabNavigationStepperItems';
import ManagerInsuranceCompaniesCaseTypes from '../ManagerInsuranceCompaniesCaseTypes/ManagerInsuranceCompaniesCaseTypes';
import ManagerInsuranceCompaniesCareClaim from '../ManagerInsuranceCompaniesCareClaim/ManagerInsuranceCompaniesCareClaim';
import ManagerInsuranceCompaniesContracted from '../ManagerInsuranceCompaniesContracted/ManagerInsuranceCompaniesContracted';
import styles from './ManagerInsuranceCompanies.module.scss';
import ManagerInsuranceCompaniesBatches from '../ManagerInsuranceCompaniesBatches/ManagerInsuranceCompaniesBatches';

const ManagerInsuranceCompanies: React.FC = () => {
	const steps: NavigationStepperItemType[] = [
		{
			name: 'component.caseType.caseTypesTitle',
			key: 'caseTypes',
			component: (params: NavigationStepperComponentParams) => (
				<ManagerInsuranceCompaniesCaseTypes
					defaultAction={() =>
						params.setActiveStepPath('contractedInsuranceCompanies')
					}
				/>
			),
		},
		{
			name: 'component.reportedCare.toReportedCareTableButton',
			key: 'reportedCare',
			component: (params: NavigationStepperComponentParams) => (
				<ManagerInsuranceCompaniesCareClaim />
			),
		},
		{
			name: 'component.caseType.toContractedInsuranceCompaniesButton',
			key: 'contractedInsuranceCompanies',
			component: (params: NavigationStepperComponentParams) => (
				<ManagerInsuranceCompaniesContracted
					onSubmit={() => params.setActiveStepPath('caseTypes')}
				/>
			),
		},
		{
			name: 'component.insuranceCompanyBatch.title',
			key: 'batches',
			component: () => <ManagerInsuranceCompaniesBatches />,
		},
	];

	return (
		<div className={styles.wrapper}>
			<NavigationStepper
				steps={steps}
				initialStepPath='caseTypes'
				canSkip
				renderItems={({ items, activeKey, onChange }) => (
					<SubTabNavigationStepperItems
						items={items}
						activeKey={activeKey}
						onChange={onChange}
					/>
				)}
			/>
		</div>
	);
};

export default ManagerInsuranceCompanies;
